const nonBreakingSpaceCharCode = 160;
// Remove all non breaking spaces (i.e '&nbsp;')
export const removeAllNonBreakingSpaces = (text: string): string => {
  return text.split(String.fromCharCode(nonBreakingSpaceCharCode)).join("");
};

// Remove all &amp; characters and replace them with '&'
export const removeAllAmpersands = (text: string): string => {
  return text.replace(/&amp;/g, "&");
};
